import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import OperatorDashboard from '@/pages/dashboard/components/OperatorDashboard';
import OwnerDashboard from '@/pages/dashboard/components/OwnerDashboard';
import MemberDashboard from '@/pages/dashboard/components/MemberDashboard';

export default function AdminPage() {
  const navigate = useNavigate();
  const { profile } = useAuth();

  const role = profile?.role;
  const title =
    role === 'operator' ? '운영 관리' : role === 'owner' ? '학원 관리' : '내 이용권';

  return (
    <div className="min-h-screen bg-background-50">
      <header className="bg-white border-b border-background-200 print:hidden">
        <div className="max-w-7xl mx-auto px-4 md:px-6 h-16 flex items-center justify-between">
          <button
            onClick={() => navigate('/dashboard')}
            className="flex items-center gap-2 text-foreground-600 hover:text-foreground-900 text-sm transition-colors cursor-pointer"
          >
            <i className="ri-arrow-left-line"></i>
            대시보드로 돌아가기
          </button>
          <div className="text-sm font-semibold text-foreground-950">{title}</div>
          <div className="w-24" />
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 md:px-6 py-8">
        {role === 'operator' ? (
          <OperatorDashboard />
        ) : role === 'owner' ? (
          <OwnerDashboard />
        ) : (
          <MemberDashboard />
        )}
      </main>
    </div>
  );
}